import { AgentAvatar, type DesklingMood } from '@/components/agent-avatar';
import { t } from '@/lib/i18n';
import { cn } from '@/lib/utils';

/** A desk's team on the landing page: the same Desklings the app draws, each in a mood (seeds picked for variety). */
const CREW: { seed: string; name: string; role: string; mood: DesklingMood; says: string; lead?: boolean }[] = [
  { seed: 'agent-0-0', name: 'Lena', role: t('Lead'), mood: 'waiting', says: t('“Reply to the customer is ready. OK?”'), lead: true },
  { seed: 'agent-7919-1', name: 'Max', role: t('Bug fixer'), mood: 'working', says: t('Fixing BR-151 on its own branch …') },
  { seed: 'agent-39595-5', name: 'Mila', role: t('Writer'), mood: 'happy', says: t('Article is live!') },
  { seed: 'agent-15838-2', name: 'Ben', role: t('Reviewer'), mood: 'working', says: t('Checking the merge request …') },
  { seed: 'agent-23757-3', name: 'Tom', role: t('Researcher'), mood: 'sleeping', says: t('Asleep until new work comes in.') },
  { seed: 'agent-55433-7', name: 'Ana', role: t('Analyst'), mood: 'sad', says: t('The login expired — tells you which one.') },
];

/**
 * "Meet the Desklings": every desk is a little team of AI agents, drawn as Desklings — the Lead with the crown plans and
 * decides, the others do the work. Their faces say at a glance who works, who sleeps and who waits for you.
 */
export function Desklings() {
  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
      {CREW.map((c, i) => (
        <figure
          key={c.seed}
          style={{ animationDelay: `${i * 90}ms` }}
          className="group flex flex-col items-center rounded-2xl border bg-card p-4 text-center shadow-sm transition-transform duration-300 hover:-translate-y-1 animate-in fade-in slide-in-from-bottom-3 fill-mode-both"
        >
          <div className={cn(c.mood === 'working' && 'deskling-bob', c.mood === 'happy' && 'deskling-hop')}>
            <AgentAvatar seed={c.seed} size={96} mood={c.mood} lead={c.lead} className="rounded-2xl" />
          </div>
          <figcaption className="mt-3">
            <div className="text-sm font-semibold">
              {c.name} <span className="font-normal text-muted-foreground">· {c.role}</span>
            </div>
            <div className="mt-1 text-xs text-muted-foreground">{c.says}</div>
          </figcaption>
        </figure>
      ))}
    </div>
  );
}
